/**
 * Quick Links Component
 * Large, prominent action cards for key pages
 */

import styles from './QuickLinks.module.css';

export class QuickLinks {
  constructor(options = {}) {
    const { links = null } = options;
    this.links = links || this.getDefaultLinks();
  }

  getDefaultLinks() {
    return [
      {
        title: 'View Schedule',
        description: 'See our class times and programs',
        icon: '📅',
        href: '#schedule',
        color: 'primary'
      },
      {
        title: 'Enroll Now',
        description: 'Join our ballet community',
        icon: '✨',
        href: '/join',
        color: 'accent'
      },
      {
        title: 'Nutcracker 2025',
        description: 'Learn about our upcoming performance',
        icon: '🎭',
        href: '/nutcracker',
        color: 'secondary'
      }
    ];
  }

  render() {
    const section = document.createElement('section');
    section.className = styles.quickLinks;

    const container = document.createElement('div');
    container.className = styles.container;

    const grid = document.createElement('div');
    grid.className = styles.grid;

    this.links.forEach(link => {
      const card = document.createElement('a');
      card.href = link.href;
      card.className = `${styles.card} ${styles[link.color]}`;

      const icon = document.createElement('div');
      icon.className = styles.icon;
      icon.textContent = link.icon;
      card.appendChild(icon);

      const content = document.createElement('div');
      content.className = styles.content;

      const title = document.createElement('h3');
      title.className = styles.title;
      title.textContent = link.title;
      content.appendChild(title);

      const description = document.createElement('p');
      description.className = styles.description;
      description.textContent = link.description;
      content.appendChild(description);

      card.appendChild(content);
      grid.appendChild(card);
    });

    container.appendChild(grid);
    section.appendChild(container);
    return section;
  }
}
